import { Component, Input, OnInit } from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { ClientMatterContactDetails } from '../../core/models/client-matter-contact-details';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
})
export class AboutUsComponent implements OnInit {
  loading = true;
  clientMatterContactDetails?: ClientMatterContactDetails;

  constructor(private clientService: ClientService) {}

  @Input() matterId? : string;

  ngOnInit(): void {
    this.getClientMatterContactDetails();
  }

  getClientMatterContactDetails()
  {
    this.clientService.getClientMatterContactDetails(this.matterId).subscribe((val) => {
      this.loading = false;
      this.clientMatterContactDetails = val;
    });
  }
}
